import { Recurso } from "lib.common/dist/CleanArch";
import { EstadosApisDtSource } from "../../bussines/dataSources/EstadosApisDtSource";
import { EstadosApisRepository } from "../../bussines/repositories/EstadosApisRepository";
import { EstadoApiModel } from "../models/EstadoApiModel";
import { ErrDevValidacion } from 'lib.common/dist/errorHandler';

export class EstadosApisRepositoryImpl implements EstadosApisRepository<EstadoApiModel> {
    private dataSource: EstadosApisDtSource;

    constructor(dataSource: EstadosApisDtSource) {
        this.dataSource = dataSource;
    }

    async getEstadosApis(): Promise<Recurso<EstadoApiModel[]>> {
        try {
            const result = await this.dataSource.getEstadosApis();

            if (result.isSuccess()) {
                return Recurso.fromData<EstadoApiModel[]>(
                    result.data!.map(EstadoApiModel.deserialize)
                );
            }
            return Recurso.fromError<EstadoApiModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadoApiModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getEstadosApisTransporte(): Promise<Recurso<EstadoApiModel[]>> {
        try {
            const result = await this.dataSource.getEstadosApisTransporte();

            if (result.isSuccess()) {
                return Recurso.fromData<EstadoApiModel[]>(
                    result.data!.map(EstadoApiModel.deserialize)
                );
            }
            return Recurso.fromError<EstadoApiModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadoApiModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
}